import React from "react";

import { useTheme } from "../../../../../context/theme";
import { Box } from "../../../../layout";
import { maxWidthMap } from "./consts";

import type { ResponsiveDimension, Dimension } from "../../../../../types";

import type { ModalProps } from "../../Modal";

type ContentBoxProps = Pick<ModalProps, "background" | "overflowY"> &
  Required<
    Pick<
      ModalProps,
      | "children"
      | "inContainer"
      | "padding"
      | "maxWidth"
      | "fullscreenOnMobile"
      | "scrollable"
    >
  >;

export default function ContentBox({
  children,
  inContainer,
  padding,
  maxWidth,
  fullscreenOnMobile,
  background,
  scrollable,
  overflowY
}: ContentBoxProps) {
  const theme = useTheme();

  const modalStyles = fullscreenOnMobile
    ? {
        height: ["100%", "unset"] as [string, string],
        borderRadius: ["none", "large"] as ResponsiveDimension
      }
    : { height: "unset", borderRadius: "large" as Dimension };

  return (
    <Box
      position={inContainer ? "absolute" : "fixed"}
      left="50%"
      top="50%"
      transform="translate(-50%, -50%)"
      margin="auto"
      paddingY={padding}
      paddingX={["xlarge", padding as Dimension]}
      maxWidth={maxWidthMap[maxWidth]}
      width="100%"
      maxHeight={["100%", "90%"]}
      overflowY={overflowY || (scrollable ? "auto" : "hidden")}
      backgroundColor={theme.foreground}
      background={background}
      {...modalStyles}
      dataTest="Modal"
    >
      {children}
    </Box>
  );
}
